import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-download",
  "use": "ico-download-usage",
  "viewBox": "0 0 13 15.16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 15.16\" id=\"ico-download\">\n  <path id=\"ico-download_Path_1532\" data-name=\"Path 1532\" d=\"M5.66,46.843a1.085,1.085,0,0,0,1.533,0l5.415-5.415A1.084,1.084,0,1,0,11.075,39.9l-3.567,3.57V33.083a1.083,1.083,0,0,0-2.166,0V43.462L1.775,39.9A1.084,1.084,0,1,0,.242,41.431l5.415,5.415Z\" transform=\"translate(0.075 -32)\" fill=\"#5393d0\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol